import React from 'react';
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { eventType } from "../../../../util/varibles/constants";
import { IEvent2, IOperation2 } from '../../../../util/varibles/interface';
import Icon, { ICON_NAME } from "../../../Icon";
import Header from "../../_components/Header";
import StepControl from "../../_components/StepControl";
import TabControl from "../../_components/TabControl";
import ActivityLogs from '../../ActivitiesLog/ActivityLogs/ActivityLogs';
import stylesOp from "../style.module.scss";

const Event: React.FC = () => {
    const [data] = useTrackingOp(state => state.op as IOperation2<IEvent2>);

    if (!data) return null;

    const { event_type } = data.operation;
    const { name = '' } = eventType[event_type] || {}

    return <>
        <Header icon={<Icon icon={ICON_NAME.EVENT} />}>
            <div className={[stylesOp['operation-route'], 'flex items-center'].join(' ')}>
                <span>{name}</span>
            </div>
        </Header>
        <TabControl>
            {[
                <div key="step" className={stylesOp['operation-info']}>
                    <div className={stylesOp['operation-content']}>
                        <StepControl />
                    </div>
                </div>,
                <ActivityLogs key="activity-log" data={data} />
            ]}
        </TabControl>

    </>;
};

export default Event;